







import { Component, Mixins, Emit, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { StringFilter, StringFilterParameter } from "../../../../base/components/system/filters";
import { EditableFormatSummaryFilterParameter } from ".";
import { DocumentKind } from "../../../../documaker/domain/format";
import { DocumentKindDropDownSelector } from "../../../../documaker/components/format/selectors";

@Component({
  components: {
    StringFilter,
    documentKindSelector: DocumentKindDropDownSelector,
  },
})
export default class EditableFormatSummaryDocumentKindFilter extends Mixins(ModelEditableMixin) {
  selectDocumentKind: DocumentKind = null;
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryFilterParameter) => void) => void;

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: EditableFormatSummaryFilterParameter, oldValue: EditableFormatSummaryFilterParameter) {
    if (newValue && oldValue && newValue.documentKind.keyword !== oldValue.documentKind.keyword && !newValue.documentKind.keyword) {
      // 基本的に上位からパラメータを更新されることはないが、クリアされたときは空にする必要がある
      this.selectDocumentKind = null;
    }
    this.updateDocumentKindText();
  }

  get documentKind(): StringFilterParameter {
    return this.readPropertyOrDefault(s => s.documentKind, null);
  }

  set documentKind(source: StringFilterParameter) {
    this.writeProperty(s => s.documentKind = source);
  }

  @Watch("selectDocumentKind")
  onSelectDocumentKindUpdated(newValue: DocumentKind, oldValue: DocumentKind): void {
    this.documentKind = newValue
      ? new StringFilterParameter(newValue.id, false)
      : new StringFilterParameter();
    this.updateDocumentKindText();
  }

  @Emit("updateText")
  updateDocumentKindText(): string {
    return this.selectDocumentKind
      ? this.selectDocumentKind.name
      : "";
  }
}
